/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.application.installs.rpc.ApplicationInstallsRpc
 */
import * as References from './ApplicationInstallsRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.application.installs.rpc.ApplicationInstallsRpc#uninstallApp
 */
export const UNINSTALL_APP_MUTATION_FIELD_NAME =
  'com_hubspot_application_installs_rpc_ApplicationInstallsRpc_uninstallApp';
export const UNINSTALL_APP_MUTATION: RegisteredQuery<
  'result',
  References.UninstallAppRequestType,
  References.UninstallAppResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UNINSTALL_APP_MUTATION_FIELD_NAME,
  args: ['appId'],
  fetcher(
    request: References.UninstallAppRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UninstallAppResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.uninstallAppRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.application.installs.rpc.ApplicationInstallsRpc#deleteAccount
 */
export const DELETE_ACCOUNT_MUTATION_FIELD_NAME =
  'com_hubspot_application_installs_rpc_ApplicationInstallsRpc_deleteAccount';
export const DELETE_ACCOUNT_MUTATION: RegisteredQuery<
  'result',
  References.DeleteAccountRequestType,
  References.DeleteAccountResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: DELETE_ACCOUNT_MUTATION_FIELD_NAME,
  args: ['appId', 'accountId'],
  fetcher(
    request: References.DeleteAccountRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.DeleteAccountResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.deleteAccountRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.application.installs.rpc.ApplicationInstallsRpc#getUserInstallInfos
 */
export const GET_USER_INSTALL_INFOS_QUERY_FIELD_NAME =
  'com_hubspot_application_installs_rpc_ApplicationInstallsRpc_getUserInstallInfos';
export const GET_USER_INSTALL_INFOS_QUERY: RegisteredQuery<
  'result',
  References.GetUserInstallInfosRequestType,
  References.GetUserInstallInfosResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_USER_INSTALL_INFOS_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(
    request: References.GetUserInstallInfosRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetUserInstallInfosResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getUserInstallInfosRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.application.installs.rpc.ApplicationInstallsRpc#uninstallAppForUser
 */
export const UNINSTALL_APP_FOR_USER_MUTATION_FIELD_NAME =
  'com_hubspot_application_installs_rpc_ApplicationInstallsRpc_uninstallAppForUser';
export const UNINSTALL_APP_FOR_USER_MUTATION: RegisteredQuery<
  'result',
  References.UninstallAppForUserRequestType,
  References.UninstallAppForUserResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UNINSTALL_APP_FOR_USER_MUTATION_FIELD_NAME,
  args: ['appId', 'userId', 'businessUnitId'],
  fetcher(
    request: References.UninstallAppForUserRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UninstallAppForUserResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.uninstallAppForUserRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.application.installs.rpc.ApplicationInstallsRpc#getInstalledAppsWithAppPermissionsForDataClassification
 */
export const GET_INSTALLED_APPS_WITH_APP_PERMISSIONS_FOR_DATA_CLASSIFICATION_QUERY_FIELD_NAME =
  'com_hubspot_application_installs_rpc_ApplicationInstallsRpc_getInstalledAppsWithAppPermissionsForDataClassification';
export const GET_INSTALLED_APPS_WITH_APP_PERMISSIONS_FOR_DATA_CLASSIFICATION_QUERY: RegisteredQuery<
  'result',
  References.GetInstalledAppsWithAppPermissionsForDataClassificationRequestType,
  References.GetInstalledAppsWithAppPermissionsForDataClassificationResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName:
    GET_INSTALLED_APPS_WITH_APP_PERMISSIONS_FOR_DATA_CLASSIFICATION_QUERY_FIELD_NAME,
  args: ['dataClassification'],
  fetcher(
    request: References.GetInstalledAppsWithAppPermissionsForDataClassificationRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetInstalledAppsWithAppPermissionsForDataClassificationResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getInstalledAppsWithAppPermissionsForDataClassificationRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
